import React, { Component } from "react";
import "./navigationButtons.scss";

class NavigationButtons extends Component {
  render() {
    const {
      previousStep,
      showPrevious,
      showNext,
      isLast,
      onSave,
    } = this.props;

    return (
      <>
        <div className="navigationButtons">
          <div className="col-50">
            <p>Campos marcados com (*) são de preenchimento obrigatório!</p>
          </div>
          <div className="col-50">
            <div className="col-50">
              {showPrevious && (
                <button onClick={previousStep} className="previous">
                  Anterior
                </button>
              )}
            </div>
            <div className="col-50">
              {showNext && (
                <button
                  onClick={!isLast ? this.nextValidar : onSave}
                  className={!isLast ? "next" : "resumo"}
                >
                  {!isLast ? "Próximo" : "Salvar"}
                </button>)}
            </div>
          </div>
        </div>
      </>
    );
  }

  nextValidar = () => {
    const { nextStep, onValidate: validate, } = this.props;
    validate().then((isValid) => isValid && nextStep());
  };
}

export default NavigationButtons;
